/**
 * Generate UUID that works in both secure (HTTPS) and non-secure (HTTP) contexts.
 *
 * Uses crypto.randomUUID() when available (secure contexts),
 * falls back to Math.random-based generation for non-secure contexts.
 */
export function generateUUID(): string {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    try {
      return crypto.randomUUID();
    } catch {
      // Falls through to fallback
    }
  }
  // Fallback for non-secure contexts (HTTP)
  // Note: Math.random() is not cryptographically secure. This fallback is
  // acceptable for request correlation IDs but NOT for security-critical purposes.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
